module.exports = __webpack_public_path__ + "static/media/index.904d64fa.less";